import styles from './BankingIngestionLine.module.scss';
import PillArrowGlyph from '../PillArrowGlyph/PillArrowGlyph';

export interface IngestionNoun {
    singular: string;
    plural: string;
}

const BANK_STATEMENT_NOUN: IngestionNoun = { singular: 'bank statement', plural: 'bank statements' };

interface BankingIngestionLineProps {
    /** From `getBankingPendingStatus`, the same fetch `store/banking` already makes. */
    failedCount: number;
    onReviewClick: () => void;
    /** What is being counted; bank statements unless a caller says otherwise. */
    noun?: IngestionNoun;
}

/** "N bank statements not ingested. Review Now" beside a tab title; nothing when N is 0. */
const BankingIngestionLine = ({ failedCount, onReviewClick, noun = BANK_STATEMENT_NOUN }: BankingIngestionLineProps) => {
    if (!failedCount) return null;

    return (
        <div className={styles.Line} role="alert">
            {`${failedCount} ${failedCount !== 1 ? noun.plural : noun.singular} not ingested. `}
            <button className={styles.ReviewLink} onClick={onReviewClick}>
                Review Now
                <PillArrowGlyph className={styles.ReviewIcon} />
            </button>
        </div>
    );
};

export default BankingIngestionLine;
